import { useMutation } from '@tanstack/react-query';
import { parseQRCode, ParseQRRequest, ParseQRResponse } from '@/api/wallet';

export const useParseQR = () => {
  return useMutation<ParseQRResponse, Error, ParseQRRequest>({
    mutationFn: parseQRCode,
  });
};
